<template>
    <div class="bio-container">
        <figure class="bio-pic image is-128x128">
            <img class="is-rounded" src="https://bulma.io/images/placeholders/128x128.png">
        </figure>
        <span class="bio-name is-family-monospace">Christopher Chua</span>
        <p class="bio-about">
            I am a graduate software developer based in Perth, Western Australia.
            <br>
            In my spare time I enjoy the game of Snooker, competitive computer games,
            cooking, and travelling.
            <br><br>
            Check out my <a>projects</a> below.
        </p>
    </div>
</template>

<script>
export default {
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">



</style>
